export const SAGA_WAITING_TIME = 750;
export const SAGA_WAITING_TIME_HALF = 400;
export const SAGA_WAITING_TIME_300 = 300;
